<template>
  <component
    v-if="debugCodeComponent && showDebugCode"
    :is="debugCodeComponent"
    :action_code_id="action_code_id"
    :code="code"
    :action="action"
    :options="options"
    :showCode="showCode"
    :disableCode="disableCode"
    :params="params"
    :show="show"
    :valueCode="valueCode"
    :dynamic-title="dynamicTitle"
    @update:action="updateAction"
    @update:code="updateCode"
    @update:showCode="updateShowCode"
    @update:disableCode="updateDisableCode"
    @update:valueCode="updateValueCode"
    @update:dynamicTitle="updateDynamicTitle"
  >
    <slot></slot>
  </component>
  <slot v-else></slot>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import CodeEditor from 'liyu-pc-base/components/code/CodeEditor.vue';
import { useDebugCodeComponent } from 'liyu-pc-base/init-plugin';

export default defineComponent({
  name: 'debugCode',
  props: {
    action_code_id: {
      type: String,
      required: false,
    },
    code: {
      required: false,
    },
    action: {
      required: false,
    },
    options: {
      type: Array,
      required: false,
    },
    showCode: {
      type: Object as PropType<{ enable: boolean; code: string } | undefined>,
      required: false,
    },
    disableCode: {
      type: Object as PropType<{ enable: boolean; code: string } | undefined>,
      required: false,
    },
    params: {
      required: false,
    },
    show: {
      required: false,
    },
    showDebugCode: {
      type: Boolean,
      default: true,
      required: false,
    },
    valueCode: {
      type: Object as PropType<{ code: string } | undefined>,
      required: false,
    },
    dynamicTitle: {
      type: Object as PropType<{ code: string } | undefined>,
      required: false,
    },
  },
  emits: [
    'update:code',
    'update:action',
    'update:showCode',
    'update:disableCode',
    'update:valueCode',
    'update:dynamicTitle',
  ],

  setup(props, { emit }) {
    const debugCodeComponent = useDebugCodeComponent();
    const updateAction = value => {
      emit('update:action', value);
    };
    const updateCode = value => {
      emit('update:code', value);
    };
    const updateShowCode = value => {
      emit('update:showCode', value);
    };
    const updateDisableCode = value => {
      emit('update:disableCode', value);
    };
    const updateValueCode = value => {
      emit('update:valueCode', value);
    };
    const updateDynamicTitle = value => {
      emit('update:dynamicTitle', value);
    };

    return {
      debugCodeComponent,
      updateAction,
      updateCode,
      updateShowCode,
      updateDisableCode,
      updateValueCode,
      updateDynamicTitle,
    };
  },
  components: {
    CodeEditor,
  },
});
</script>
